import { Injectable } from '@angular/core';

import { TokenControlService } from "../services/state/tokenControl.service";
import { ActivatedRoute, Router } from '@angular/router';
import { Component } from '@angular/core';

@Injectable()
export class SyncGuard  {

  //Indica si tiene los privilegios para sincronizar
  public canSync:boolean;

  //Constructor de la clase
  constructor(private _router: Router) {
      this.canSync=false;
  }

  /*Necesario debido a implementacion de la interfaz CanActivate
    funcion principal del guard, verifica si se cumplen las
    condiciones para permitir la navegacion */
  canActivate() {
      let canActivate = false;
      if(this.canSync){
        canActivate=true;
      }else{
        this._router.navigate(['/']);
      }
    return canActivate
  }
}
